export default "__VITE_ASSET__Dpzz7EfO__"